import { Gender } from "./user";

// NOT(0, "未知"), NO(1, "未婚"), YES(2, "已婚");
export enum MaritalStatus {
  Unknown = 0,
  Single = 1,
  Married = 2,
}

export function getMaritalStatusName(status: MaritalStatus): string {
  switch (status) {
    case MaritalStatus.Unknown:
      return "未知";
    case MaritalStatus.Single:
      return "未婚";
    case MaritalStatus.Married:
      return "已婚";
  }
  return "";
}
export interface Patient {
  id: string;
  name: string;
  status: number;
  sex: Gender;
  phone: string;
  address: string;
  ageMonth: number;
  ageYear: number;
  birthday: string;
  companyName: string;
  idCardNumber: string;
  emergencyContactName: string;
  emergencyContactPhone: string;
  tenantPatientCardId: string;
  labelName: string;
  maritalStatus: number;
  nation: string;
  emailAddress: string;
  remark: string;
}

export function fromJson(json: any): Patient {
  return {
    id: json.id?.toString() || "",
    name: json.name,
    status: json.status,
    sex: json.sex === -1 ? Gender.Unknown : json.sex,
    phone: json.phone,
    address: json.address,
    ageMonth: json.ageMonth,
    ageYear: json.ageYear > 0 ? json.ageYear : 0,
    birthday: json.birthday,
    companyName: json.companyName,
    idCardNumber: json.idCardNumber,
    emergencyContactName: json.emergencyContactName,
    emergencyContactPhone: json.emergencyContactPhone,
    tenantPatientCardId: json.tenantPatientCardId,
    labelName: json.labelName,
    maritalStatus:
      json.maritalStatus === -1 ? MaritalStatus.Unknown : json.maritalStatus,
    nation: json.nation,
    emailAddress: json.emailAddress,
    remark: json.remark,
  };
}

export function toJson(patient: Patient): any {
  return {
    id: patient.id,
    name: patient.name,
    sex: patient.sex,
    phone: patient.phone,
    address: patient.address,
    ageMonth: patient.ageMonth,
    ageYear: patient.ageYear,
    birthday: patient.birthday,
    idCardNumber: patient.idCardNumber,
    companyName: patient.companyName,
    emergencyContactName: patient.emergencyContactName,
    emergencyContactPhone: patient.emergencyContactPhone,
    tenantPatientCardId: patient.tenantPatientCardId,
    labelName: patient.labelName,
    maritalStatus: patient.maritalStatus,
    nation: patient.nation,
    emailAddress: patient.emailAddress,
    remark: patient.remark,
  };
}
